<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Motivo de la denegación</h4>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
  
<div class="modal-body">
  <h5 style="font-size: 1.125rem;">El {{ user }} {{ name }}:</h5>
  <p>
    {{ comments }}
  </p>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="modal.dismiss('cancel click')"
  >
    Cerrar
  </button>
</div>
  